import "./scss/reset.scss";
import "./scss/init.scss";
import "./scss/index.scss";

import "./js/setMeta";
import "./js/analy";
import "./js/init";
